const playerReducer = (state = [], _) => {
  return state;
};

export default playerReducer;
